import { AlertTriangle, Loader2 } from "lucide-react";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";

export default function ConfirmModal({ open, onClose, onConfirm, title, message, confirmLabel = "Confirmar", danger = true, loading = false, testid = "confirm-modal" }) {
  return (
    <Dialog open={open} onOpenChange={(v) => !v && onClose()}>
      <DialogContent className="glass-card text-slate-100 sm:max-w-md" data-testid={testid}>
        <DialogHeader>
          <DialogTitle className="font-heading text-lg font-bold text-slate-100 flex items-center gap-2.5">
            {danger && <AlertTriangle className="w-5 h-5 text-red-400 shrink-0" />}
            {title}
          </DialogTitle>
        </DialogHeader>
        <DialogDescription className="text-sm text-slate-400 leading-relaxed" data-testid={`${testid}-message`}>{message}</DialogDescription>
        <div className="flex justify-end gap-3 mt-2">
          <Button variant="outline" onClick={onClose} disabled={loading}
            data-testid={`${testid}-cancel`}
            className="border-slate-700 text-slate-300 hover:bg-slate-800">
            Cancelar
          </Button>
          <Button onClick={onConfirm} disabled={loading}
            data-testid={`${testid}-confirm`}
            className={danger
              ? "bg-red-500 hover:bg-red-600 text-white font-semibold"
              : "bg-emerald-500 hover:bg-emerald-600 text-emerald-950 font-semibold"}>
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : confirmLabel}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
